import React from "react";

const colorClass = {
  green: "text-icon-green hover:text-primary",
  blue: "text-icon-blue hover:text-blue-700",
  red: "text-icon-red hover:text-red-700",
  orange: "text-icon-orange hover:text-amber-700",
  purple: "text-icon-purple hover:text-purple-700",
  yellow: "text-icon-yellow hover:text-yellow-700",
  slate: "text-slate-500 hover:text-slate-800",
};

function ActionGroup({ children }) {
  return <div className="flex items-center justify-end gap-3">{children}</div>;
}

export function ActionButton({
  children,
  title,
  onClick,
  color = "slate",
  as: Component = "button",
  ...props
}) {
  const className = `inline-flex h-8 w-8 items-center justify-center rounded-md ${
    colorClass[color] ?? colorClass.slate
  } transition-colors`;

  if (Component === "button") {
    return (
      <button
        type="button"
        className={className}
        title={title}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    );
  }

  return (
    <Component className={className} title={title} onClick={onClick} {...props}>
      {children}
    </Component>
  );
}

export default ActionGroup;
